import { Venue } from "common/types";
import { atom, useAtom } from "jotai";

export const selectedLocationAtom = atom<Venue | null>(null as Venue | null);

export function useSelectedLocation() {
  const [selectedLocation, setSelectedLocation] = useAtom(selectedLocationAtom);
  return { selectedLocation, setSelectedLocation };
}
